<template>
  <section class="mt-3" id="chart">
    <b-row class="mt-4">
      <b-col cols="6" sm="12" md="6" lg="6" xl="6">
        <!--<div v-if="!reportMode" class="mx-1 button_container">
          <b-button v-if="filter.mode === 'MEASURES' " variant="default" @click="euroButtonClick()">
            <img title="Visualizza costi" src="/static/icons/icon-6.png" width="16">
          </b-button>
        </div>-->
        <div v-if="!reportMode" class="mx-1 button_container">
          <b-button
            variant="default"
            :class="filter.enableTruncatedAverage ? 'btn btn-primary white' : ''"
            @click="$bvModal.show('modal-average')"
          >
            <font-awesome-icon icon="scissors" />
          </b-button>
          <b-button
            v-if="filter.mode === 'MEASURES'"
            variant="default"
            :class="{ selected: isEnergyMode }"
            @click="measuresButtonClick()"
          >
            <font-awesome-icon icon="fa-solid fa-bolt" />
          </b-button>
          <b-button
            v-if="filter.mode === 'MEASURES'"
            variant="default"
            :class="{ selected: filter.co2 }"
            @click="co2ButtonClick()"
          >
            <font-awesome-icon icon="fa-solid fa-smog" />
          </b-button>
          <b-button
            v-if="filter.mode === 'MEASURES'"
            variant="default"
            :class="{ selected: filter.tep }"
            @click="tepButtonClick()"
          >
            <font-awesome-icon icon="fa-solid fa-fire" />
          </b-button>
        </div>

        <div style="height: 50%" :id="chartId"></div>
      </b-col>
      <b-col>
        <b-table
          striped
          hover
          :items="tableData"
          foot-clone
          :fields="tableFields"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
        >
          <template #cell(perc)="data">
            <b v-if="data.item.perc >= 0" class="perc_text">{{ formatNum(data.item.perc) }}%</b>
            <b v-else class="perc_text">0%</b>
          </template>
          <template #cell(value)="data">
            <span v-if="muList.length > 1">{{ data.item.value }} {{ data.item.mu }}</span>
            <span v-else>{{ data.item.value }}</span>
          </template>
          <template #foot(perc)=""> 100% </template>
          <template #foot(name)="">
            <span>Totale</span>
          </template>
          <template #foot(value)="">
            <div v-for="(value, index) in totalValue" :key="index">
              <span>{{ value.value }}</span
              ><span v-if="muList.length > 1"> {{ value.mu }}</span>
            </div>
          </template>
        </b-table>

        <b-alert variant="warning" :show="muList.length > 1"
          >Attenzione: non è possibile confrontare correttamente dati con unità di misura eterogenee</b-alert
        >
      </b-col>
    </b-row>
    <b-modal id="modal-average" ref="modalAverage" size="lg" title="Applica media troncata" :hide-footer="true">
      <form role="form" ref="form" class="needs-validation" novalidate @submit.prevent="checkAverageForm()">
        <div class="mb-3">
          <label class="label-control">
            <input type="checkbox" v-model="average.enableTruncatedAverage" />
            Applica media troncata
          </label>
        </div>
        <label class="label-control d-block">Percentuale elementi esclusi (max 45%)</label>
        <input
          type="number"
          class="form-control average-number"
          min="0"
          max="45"
          v-model="average.truncatedAverageExclude"
          :disabled="!average.enableTruncatedAverage"
          required
        />
        <label class="label-control">%</label>
        <div class="mt-3">
          <label class="label-control d-block">Moltiplicatore</label>
          <input
            type="number"
            class="form-control average-number"
            min="1"
            v-model="average.truncatedAverageMultiplier"
            :disabled="!average.enableTruncatedAverage"
            required
          />
        </div>
        <div class="d-flex justify-content-end">
          <b-btn variant="secondary" @click="$bvModal.hide('modal-average')">Annulla</b-btn>
          <button type="submit" class="btn btn-primary ml-2">Applica</button>
        </div>
      </form>
    </b-modal>
  </section>
</template>

<script>
import NeedUpdateMixin from "../../NeedUpdateMixin";
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4lang_it_IT from "@amcharts/amcharts4/lang/it_IT";
import { makeid } from "../../helpers";
import { startRender, finishRender } from "../../../../helpers/printReady";

var moment = require("moment");

export default {
  name: "PieChart",
  props: ["filter", "reportMode", "maxMonth"],

  mixins: [NeedUpdateMixin],

  created() {
    this.filter = this.filter;
    this.reload();
  },

  beforeDestroy() {
    this.unload();
  },

  data() {
    return {
      tableData: [],
      chartId: makeid(),
      totalValue: [],
      sortBy: "name",
      sortDesc: false,
      tableFields: [
        { key: "name", sortable: true, label: "Nome" },
        { key: "perc", sortable: true, label: "%" },
      ],
      average: {
        enableTruncatedAverage: false,
        truncatedAverageExclude: 20,
        truncatedAverageMultiplier: 20,
      },
      muList: [],
      isEnergyMode: true,
    };
  },

  watch: {
    filter() {
      _.debounce(this.reload, 10)();
    },
  },

  methods: {
    co2ButtonClick() {
      this.filter.co2 = true;
      this.filter.costs = false;
      this.isEnergyMode = false;
      this.filter.tep = false;
      this.reload();
    },
    tepButtonClick() {
      this.filter.co2 = false;
      this.filter.costs = false;
      this.isEnergyMode = false;
      this.filter.tep = true;
      this.reload();
    },
    measuresButtonClick() {
      this.filter.costs = false;
      this.filter.co2 = false;
      this.isEnergyMode = true;
      this.filter.tep = false;
      this.reload();
    },
    applyAverage() {
      if (this.average.enableTruncatedAverage) {
        this.filter.enableTruncatedAverage = true;
        this.filter.truncatedAverageExclude = this.average.truncatedAverageExclude / 100;
        this.filter.truncatedAverageMultiplier = this.average.truncatedAverageMultiplier;
      } else {
        this.filter.enableTruncatedAverage = false;
        this.filter.truncatedAverageExclude = null;
        this.filter.truncatedAverageMultiplier = null;
      }

      this.reload();
      this.$refs.modalAverage.hide();
    },
    checkAverageForm() {
      if (!this.$refs.form.checkValidity()) {
        this.$refs.form.classList.add("was-validated");
        this.$notify({
          type: "error",
          text: "Compilare i campi obbligatori",
          title: "Errore",
        });
        return;
      }
      this.applyAverage();
    },
    async reload() {
      this.$store.commit("loading");

      this.unload();
      try {
        if (this.filter.channels.length === 0) {
          return;
        }
        let filter = { ...this.filter };

        if (this.maxMonth) {
          filter.fromMonth = moment(this.maxMonth, "MM-YYYY").format("MM-YYYY");
          filter.toMonth = moment(this.maxMonth, "MM-YYYY").format("MM-YYYY");
        }

        const data = await this.$store.dispatch("charts/get", filter);

        this.createAmPieChart(data);
      } finally {
        this.$store.commit("stopLoading");
      }
    },

    createAmPieChart(data) {
      try {
        let total = 0;
        let series = [];

        data.columns.forEach((c, i) => {
          if (i == 0) return;
          let value = 0;
          data.values.forEach((v) => {
            value += v[i];
          });
          value = Number(value.toFixed(2));
          total += value;
          const mu = data.mus[i - 1];
          series.push({
            name: `${c}`,
            unit: ` ${mu}`,
            value: Number(value),
          });
        });

        // Valorize table data
        this.tableData = series.map((ele) => {
          let per = (ele.value / total) * 100;
          let obj = {
            name: ele.name,
            perc: per,
            value: ele.value,
            mu: ele.unit,
          };
          return obj;
        });

        // Push each mu into totalValue
        this.muList = [];
        this.totalValue = [];
        data.mus.forEach((item) => {
          if (!this.muList.includes(item)) {
            this.muList.push(item);
          }
          if (!this.totalValue.find((value) => value.mu == item)) {
            this.totalValue.push({ mu: item, value: 0 });
          }
        });

        // Reset table fields
        this.tableFields = [
          { key: "name", sortable: true, label: "Nome" },
          { key: "perc", sortable: true, label: "%" },
        ];

        // Push a field, depending from muList
        if (this.muList.length < 2) {
          this.tableFields.push({ key: "value", sortable: true, label: this.muList[0] });
        } else {
          this.tableFields.push({ key: "value", sortable: false, label: "" });
        }

        // Valorize totalValue
        this.tableData.map((item) => {
          this.totalValue.forEach((total) => {
            if (total.mu.trim() == item.mu.trim()) {
              total.value += item.value;
            }
          });
          item.value = this.formatNum(item.value);
          return item;
        });
        this.totalValue.forEach((item) => (item.value = this.formatNum(item.value)));

        // Create chart instance
        var chart = am4core.create(this.chartId, am4charts.PieChart);

        // Track async rendering so the Puppeteer print service waits for the
        // chart to finish drawing before generating the PDF.
        startRender();
        let renderSettled = false;
        const settleRender = () => {
          if (renderSettled) return;
          renderSettled = true;
          finishRender();
        };
        chart.events.on("ready", settleRender);
        setTimeout(settleRender, 8000);

        chart.language.locale = am4lang_it_IT;
        chart.radius = am4core.percent(90);

        if (this.reportMode) {
          chart.fontSize = 10;
        }

        // Add data
        chart.data = series;

        let colors = this.$store.state.colors;
        var colorSet = new am4core.ColorSet();
        colorSet.list = colors.map(function (color) {
          return new am4core.color(color);
        });

        // Add and configure Series
        var pieSeries = chart.series.push(new am4charts.PieSeries());
        pieSeries.labels.template.maxWidth = 130;
        pieSeries.colors = colorSet;

        pieSeries.dataFields.value = "value";
        pieSeries.dataFields.category = "name";
        pieSeries.slices.template.stroke = am4core.color("#fff");
        pieSeries.slices.template.strokeOpacity = 1;

        pieSeries.ticks.template.disabled = false;
        pieSeries.alignLabels = true;

        // tooltip settings
        pieSeries.tooltip.getFillFromObject = false;
        pieSeries.tooltip.autoTextColor = false;
        pieSeries.tooltip.label.fill = am4core.color("black");
        //pieSeries.labels.template.fill = am4core.color("white");
        pieSeries.slices.template.tooltipText = "{name} [[{unit}]]: [bold] {value}";
        pieSeries.labels.template.text = "{value.percent.formatNumber('#.0')}%";
        // pieSeries.labels.template.radius = am4core.percent(10);
        pieSeries.labels.template.fontSize = 14;
        if (this.reportMode) {
          pieSeries.labels.template.fontSize = 10;
        }
        //pieSeries.labels.template.fill = am4core.color("white");
        var hs = pieSeries.slices.template.states.getKey("hover");
        hs.properties.scale = 1;

        chart.hiddenState.properties.radius = am4core.percent(0);
      } catch (error) {
        console.log(error);
      }
    },

    euroButtonClick() {
      this.filter.costs = !this.filter.costs;
      this.reload();
    },

    unload() {
      if (this.chart) {
        this.chart.dispose();
      }
      this.chart = undefined;
    },

    formatNum(num) {
      let numArr = Number(num).toFixed(2).toString().split(".");

      if (numArr.length > 0) {
        var finalNum = numArr[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, "'") + "," + numArr[1];
      } else {
        var finalNum = numArr[0].toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".");
      }
      return finalNum;
    },
  },
};
</script>

<style scoped>
.white {
  color: white !important;
}
.average-number {
  max-width: 120px;
  display: inline-block;
}
.button_container {
  display: flex;
  justify-content: flex-end;
}
.perc_text {
  font-weight: 400;
}
</style>



// WEBPACK FOOTER //
// src/components/Charts/Types/Am/Pie.vue